{
  "archetype": "generic",
  "blockType": "feature-grid",
  "contentHash": "83d42f166181b582a61db9927c82469b402086a9e6b2dedad245cc48053c7254",
  "description": "Simple 3x3 feature grid. Each cell has an icon, title, and description. Responsive 1→2→3 column layout with stagger animation.",
  "files": {
    "block": "block.cogo.json",
    "datasource": "datasource.cogo.json",
    "events": "events.cogo.json",
    "flow": "flow.cogo.json",
    "ui": "ui.cogo.json",
    "variables": "variables.cogo.json"
  },
  "generatedAt": "2026-04-25T02:24:03.491Z",
  "lifecycle": {
    "onMount": "featureGridMount"
  },
  "metadata": {
    "author": "cogo",
    "category": "feature",
    "id": "feature-grid",
    "qualityTier": "golden",
    "tags": [
      "feature",
      "grid",
      "icon",
      "responsive",
      "stagger",
      "animation",
      "landing"
    ]
  },
  "name": "feature-grid",
  "permissions": {
    "forkable": true,
    "remixable": true,
    "visibility": "public"
  },
  "schemaVersion": "4.0",
  "socialMetadata": {
    "commentCount": 0,
    "fireCount": 0,
    "forkCount": 0
  },
  "stateContract": {
    "inputSymbols": [],
    "localState": {},
    "outputSymbols": []
  },
  "type": "ui",
  "version": "2.0.0"
}
